import React from "react";
//#region types
import { TablePaginationProps } from "models/propTypes/simpleTableProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid, InputBase, MenuItem, SelectChangeEvent, Pagination, PaginationItem } from "@mui/material";
import ControlledSelect from "../forms/baseFields/select";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const TableFooter: React.FC<TablePaginationProps> = (props) => {
  const { total, rowsPerPage, maxRowsPerPage, currentPage, hideIfSinglePage } = props;
  const numOfPages = Math.ceil(total / props.rowsPerPage);

  const handleChangePage = (event: object, page: number) => {
    props.changePageHandler(page - 1);
  };

  const onRowCountChange = (event: SelectChangeEvent<number | string>) => {
    const numOfRows = Number(event.target.value);
    props.changeRowsPerPageHandler(numOfRows);
  };

  const pageCounts = [10, 20, 30, 40];

  return hideIfSinglePage && total <= rowsPerPage ? (
    <></>
  ) : (
    <Grid container direction="row" className={cssExports.tableFooter}>
      {props.advancedPagination && !props.hideItemRange && (
        <Grid item>
          {currentPage * rowsPerPage + 1}-{Math.min(currentPage * rowsPerPage + rowsPerPage, total)}{" "}
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Of)} {total}
        </Grid>
      )}
      <Grid item xs>
        <Pagination
          count={numOfPages}
          boundaryCount={2}
          page={currentPage + 1}
          onChange={handleChangePage}
          classes={{
            root: cssExports.pagination,
            ul: cssExports.paginationUl,
          }}
          renderItem={(item: any) => (
            <PaginationItem
              {...item}
              classes={{
                root: cssExports.page,
                selected: cssExports.selectedPage,
              }}
            />
          )}
        />
      </Grid>
      {props.advancedPagination && !props.hideRowsPerPageSelector && (
        <Grid item className={cssExports.rowCountContainer}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.RowsPerPage)}
          <ControlledSelect
            value={rowsPerPage}
            onChange={onRowCountChange}
            classes={{ select: cssExports.select }}
            input={<InputBase />}
          >
            {pageCounts
              .filter((x) => maxRowsPerPage === undefined || x <= maxRowsPerPage)
              .map((pageCount) => (
                <MenuItem
                  key={pageCount}
                  classes={{ root: cssExports.popoverItem, selected: cssExports.selected }}
                  value={pageCount}
                >
                  {pageCount}
                </MenuItem>
              ))}
          </ControlledSelect>
        </Grid>
      )}
    </Grid>
  );
};

export default TableFooter;
